export const isMockAuth = import.meta.env.VITE_AUTH_MOCK === "1";

function get(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name] as string | undefined;
  if (isMockAuth) return value ?? `mock-${String(name)}`;
  if (!value) throw new Error(`Missing required env var: ${String(name)}. Copy .env.example to .env and fill it in (or set VITE_AUTH_MOCK=1).`);
  return value;
}

export const cognitoConfig = {
  region: get("VITE_COGNITO_REGION"),
  userPoolId: get("VITE_COGNITO_USER_POOL_ID"),
  clientId: get("VITE_COGNITO_CLIENT_ID"),
  domain: get("VITE_COGNITO_DOMAIN"),
  redirectUri: get("VITE_COGNITO_REDIRECT_URI"),
  logoutUri: get("VITE_COGNITO_LOGOUT_URI"),
};

export type CognitoConfig = typeof cognitoConfig;

export const mockUser = {
  sub: import.meta.env.VITE_AUTH_MOCK_SUB ?? "mock-user-1",
  email: import.meta.env.VITE_AUTH_MOCK_EMAIL ?? "mock@example.com",
  givenName: import.meta.env.VITE_AUTH_MOCK_GIVEN_NAME ?? "Mock",
  familyName: import.meta.env.VITE_AUTH_MOCK_FAMILY_NAME ?? "User",
};
